import { Link } from "react-router-dom";
import { useApp } from "../../common/contexts/AppContext";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useComponents from "../../common/hooks/pages/useComponents";
import { useQuery } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import ListComponents from "../components/ListComponents";
import ApiValidate from "../../common/components/ApiValidate";
import DeleteModal from "../../common/components/DeleteModal";

function ListComponentsContainer() {
  const { isOwner } = useApp();

  const { getComponents, getComponentStatusTypes } = useComponents();

  const { toast } = usePopup();

  const { data, isError, isLoading } = useQuery({
    retry: false,
    queryKey: "getComponents",
    queryFn: getComponents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting components!";

      toast(message, "error");
    },
  });

  const { data: statusTypesData } = useQuery({
    retry: false,
    queryKey: "getComponentStatusTypes",
    queryFn: getComponentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting component status types!";

      toast(message, "error");
    },
  });

  const { components } = data?.data || {};

  const { componentStatusTypes } = statusTypesData?.data || {};

  return (
    <BaseContainerWrapper>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Components</div>
        {isOwner ? (
          <Link
            to="/component-form"
            className="rounded-md common_bg text-white px-4 py-2 nav_link-500 transition ease-in-out duration-300"
          >
            Add component
          </Link>
        ) : null}
      </div>

      <ApiValidate isLoading={isLoading} isError={isError}>
        {components?.length ? (
          <ListComponents
            components={components}
            componentStatusTypes={componentStatusTypes}
          />
        ) : (
          <div className="mt-6 text-gray-500">Components not found</div>
        )}
        <DeleteModal
          title={`Are you sure, you want to delete this Component?`}
        />
      </ApiValidate>
    </BaseContainerWrapper>
  );
}

export default ListComponentsContainer;
